import type { SVGProps } from 'react';
import type React from 'react';

export function DataWarehouseIconStack(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 112 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_11_3893)">
        <g clipPath="url(#clip0_11_3893)">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 5.30292 26.0415)"
            fill="white"
          />
          <g clipPath="url(#clip1_11_3893)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.0599 17.9468L14.9135 14.4072L13.0599 10.8676L12.3006 11.2933V17.5211L13.0599 17.9468Z"
              fill="#E25444"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.0599 17.9468L16.7671 17.5211L18.6542 14.4072L16.7671 11.2933L13.0599 10.8676V17.9468Z"
              fill="#7B1D13"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.5413 17.9468L21.1443 17.6779V11.1364L20.5413 10.8676L16.7671 14.4072L20.5413 17.9468Z"
              fill="#58150D"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.5494 17.9541L16.7621 16.8987V11.8208L20.5494 10.865V17.9541Z"
              fill="#E25444"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.7601 16.3412L18.3682 16.6001L16.7601 18.4321L15.1559 16.6001L16.7601 16.3412Z"
              fill="#58150D"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.1559 16.6001L16.7621 16.3373L18.3682 16.6001V18.4321"
              fill="#58150D"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.7601 12.498L18.3682 12.1993L16.7601 10.6262L15.1559 12.1993L16.7601 12.498Z"
              fill="#58150D"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.7671 19.8062L18.3751 18.9549V16.6026L16.7621 17.0581L16.7671 19.8062Z"
              fill="#7B1D13"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.7621 15.7637L18.3682 15.5884V13.2398L16.7621 13.0555V15.7637Z"
              fill="#7B1D13"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.7621 11.8011L18.3682 12.2051V9.89622L16.7621 9.05305V11.8011Z"
              fill="#7B1D13"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.1559 12.2051L16.7621 11.801V9.05305L15.1559 9.89622V12.2051Z"
              fill="#E25444"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.7621 15.7637L15.1559 15.5884V13.2398L16.7621 13.0555V15.7637Z"
              fill="#E25444"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.7671 19.8062L15.1591 18.9549V16.6026L16.7671 17.0507V19.8062Z"
              fill="#E25444"
            />
          </g>
          <g style={{ mixBlendMode: 'color' }} filter="url(#filter1_d_11_3893)">
            <rect
              width="23.5043"
              height="23.5043"
              rx="11.7522"
              transform="matrix(1 0 0 -1 5.35565 26.0415)"
              fill="white"
            />
            <rect
              x="0.489673"
              y="-0.489673"
              width="22.525"
              height="22.525"
              rx="11.2625"
              transform="matrix(1 0 0 -1 5.35565 25.0622)"
              stroke="#DDDDE0"
              strokeWidth="0.979346"
            />
          </g>
        </g>
        <rect
          x="0.489673"
          y="-0.489673"
          width="22.525"
          height="22.525"
          rx="11.2625"
          transform="matrix(1 0 0 -1 5.30292 25.0622)"
          stroke="#DDDDE0"
          strokeWidth="0.979346"
        />
      </g>
      <g filter="url(#filter2_d_11_3893)">
        <g clipPath="url(#clip2_11_3893)">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 31.4188 26.0415)"
            fill="white"
          />
          <rect
            x="37.485"
            y="8.6958"
            width="11.0877"
            height="11.4701"
            fill="url(#pattern0_11_3893)"
          />
          <g style={{ mixBlendMode: 'color' }} filter="url(#filter3_d_11_3893)">
            <rect
              width="23.5043"
              height="23.5043"
              rx="11.7522"
              transform="matrix(1 0 0 -1 31.4734 26.0415)"
              fill="white"
            />
            <rect
              x="0.489673"
              y="-0.489673"
              width="22.525"
              height="22.525"
              rx="11.2625"
              transform="matrix(1 0 0 -1 31.4734 25.0622)"
              stroke="#DDDDE0"
              strokeWidth="0.979346"
            />
          </g>
        </g>
        <rect
          x="0.489673"
          y="-0.489673"
          width="22.525"
          height="22.525"
          rx="11.2625"
          transform="matrix(1 0 0 -1 31.4188 25.0622)"
          stroke="#DDDDE0"
          strokeWidth="0.979346"
        />
      </g>
      <g filter="url(#filter4_d_11_3893)">
        <g clipPath="url(#clip3_11_3893)">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 57.5347 26.0415)"
            fill="white"
          />
          <g clipPath="url(#clip4_11_3893)">
            <path
              d="M70.6469 20.146H70.7884L73.0969 19.0096L73.1353 18.9561V9.88503L73.0969 9.83129L70.7884 8.6958H70.6452L70.6469 20.146Z"
              fill="#5294CF"
            />
            <path
              d="M67.6427 20.146H67.4993L65.1927 19.0096L65.1459 18.9303L65.1222 9.93123L65.1927 9.83129L67.4993 8.6958H67.6445L67.6427 20.146Z"
              fill="#1F5B98"
            />
            <path
              d="M67.5034 8.6958H70.7861V20.146H67.5034V8.6958Z"
              fill="#2D72B8"
            />
            <path
              d="M74.3053 14.1637L74.2273 14.1467L73.1134 14.0444L73.0969 14.0525L70.7863 13.9616H67.5034L65.1927 14.0525V12.318L65.1903 12.3192L65.1927 12.3142L67.5034 11.7871H70.7863L73.0969 12.3142L73.9463 12.7586V12.4729L74.3053 12.4342L74.2681 12.3629L73.1315 11.5628L73.0969 11.5738L70.7863 10.869H67.5034L65.1927 11.5738V9.8313L63.9844 11.2249V12.442L63.9937 12.4353L64.3433 12.4729V12.7645L63.9844 12.9536V14.1647L63.9937 14.1637L64.3433 14.1688V14.6771L64.0417 14.6815L63.9844 14.6761V15.8876L64.3433 16.0777V16.3727L63.9994 16.4101L63.9844 16.3989V17.6158L65.1927 19.0096V17.2673L67.5034 17.9721H70.7863L73.1037 17.2652L73.1345 17.2785L74.2561 16.4902L74.3053 16.4116L73.9463 16.3727V16.0836L73.8993 16.0651L73.1315 16.4725L73.1037 16.5296L70.7863 17.0537V17.0543H67.5034V17.0537L65.1927 16.5274V14.7865L67.5034 14.8772V14.8794H70.7863L73.0969 14.7865L73.1495 14.8103L74.2291 14.7188L74.3053 14.6822L73.9463 14.6771V14.1688L74.3053 14.1637Z"
              fill="#1A476F"
            />
            <path
              d="M73.0969 17.2673V19.0096L74.3053 17.6158V16.4069L73.1038 17.2652L73.0969 17.2673ZM73.0969 16.5312L73.1038 16.5296L74.3053 15.8935V14.6771L73.0969 14.7865V16.5312ZM73.1038 12.3157L73.0969 12.3142V14.0525L74.3053 14.1637V12.9479L73.1038 12.3157ZM73.1038 11.5807L74.3053 12.4342V11.2252L73.0969 9.8313V11.5738L73.1038 11.5762V11.5807Z"
              fill="#2D72B8"
            />
          </g>
          <g style={{ mixBlendMode: 'color' }} filter="url(#filter5_d_11_3893)">
            <rect
              width="23.5043"
              height="23.5043"
              rx="11.7522"
              transform="matrix(1 0 0 -1 57.5894 26.0415)"
              fill="white"
            />
            <rect
              x="0.489673"
              y="-0.489673"
              width="22.525"
              height="22.525"
              rx="11.2625"
              transform="matrix(1 0 0 -1 57.5894 25.0622)"
              stroke="#DDDDE0"
              strokeWidth="0.979346"
            />
          </g>
        </g>
        <rect
          x="0.489673"
          y="-0.489673"
          width="22.525"
          height="22.525"
          rx="11.2625"
          transform="matrix(1 0 0 -1 57.5347 25.0622)"
          stroke="#DDDDE0"
          strokeWidth="0.979346"
        />
      </g>
      <g filter="url(#filter6_d_11_3893)">
        <g clipPath="url(#clip5_11_3893)">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 83.6506 26.0415)"
            fill="white"
          />
          <path
            d="M93.3494 9.07825H96.7435L93.2201 19.4188C93.1838 19.525 93.1149 19.6173 93.0229 19.6827C92.931 19.7482 92.8206 19.7834 92.7074 19.7834H90.0659C89.9802 19.7834 89.8956 19.7632 89.8193 19.7244C89.743 19.6856 89.677 19.6294 89.627 19.5604C89.577 19.4913 89.5442 19.4115 89.5315 19.3275C89.5188 19.2434 89.5265 19.1576 89.5539 19.0771L92.8366 9.44288C92.8728 9.33658 92.9417 9.2442 93.0337 9.17877C93.1257 9.11333 93.2361 9.07826 93.3494 9.07825Z"
            fill="url(#paint0_linear_11_3893)"
          />
          <path
            d="M98.2815 16.0142H92.8993C92.8492 16.0141 92.8003 16.029 92.759 16.0568C92.7176 16.0847 92.6856 16.1243 92.6673 16.1704C92.6489 16.2165 92.645 16.267 92.656 16.3153C92.6671 16.3637 92.6926 16.4076 92.7292 16.4414L96.1877 19.6388C96.2884 19.7319 96.4209 19.7836 96.5586 19.7836H99.6063L98.2815 16.0142Z"
            fill="#0078D4"
          />
          <path
            d="M93.3493 9.07813C93.2349 9.07769 93.1232 9.11353 93.0307 9.18041C92.9383 9.24729 92.8698 9.3417 92.8354 9.44985L89.5579 19.0682C89.5287 19.149 89.5195 19.2356 89.5312 19.3207C89.5428 19.4057 89.575 19.4868 89.625 19.5569C89.6749 19.6271 89.7412 19.6842 89.8182 19.7236C89.8952 19.763 89.9807 19.7835 90.0674 19.7833H92.777C92.8779 19.7654 92.9722 19.7213 93.0503 19.6555C93.1284 19.5897 93.1875 19.5046 93.2215 19.4088L93.8751 17.5009L96.2097 19.6578C96.3075 19.7379 96.4302 19.7822 96.5572 19.7833H99.5934L98.2618 16.0138L94.3798 16.0147L96.7557 9.07813H93.3493Z"
            fill="url(#paint1_linear_11_3893)"
          />
          <path
            d="M97.6845 9.44223C97.6483 9.3361 97.5795 9.24388 97.4876 9.17856C97.3957 9.11324 97.2855 9.07811 97.1724 9.07813H93.3898C93.5028 9.07813 93.6131 9.11327 93.7049 9.17859C93.7968 9.2439 93.8656 9.33611 93.9018 9.44223L97.1846 19.0769C97.212 19.1574 97.2197 19.2432 97.207 19.3273C97.1943 19.4113 97.1616 19.4912 97.1115 19.5602C97.0615 19.6293 96.9956 19.6855 96.9193 19.7243C96.8429 19.7631 96.7583 19.7834 96.6725 19.7834H100.455C100.541 19.7834 100.626 19.7631 100.702 19.7243C100.778 19.6855 100.844 19.6292 100.894 19.5602C100.944 19.4911 100.977 19.4113 100.99 19.3272C101.002 19.2432 100.995 19.1574 100.967 19.0769L97.6845 9.44223Z"
            fill="url(#paint2_linear_11_3893)"
          />
          <g style={{ mixBlendMode: 'color' }} filter="url(#filter7_d_11_3893)">
            <rect
              width="23.5043"
              height="23.5043"
              rx="11.7522"
              transform="matrix(1 0 0 -1 83.7052 26.0415)"
              fill="white"
            />
            <rect
              x="0.489673"
              y="-0.489673"
              width="22.525"
              height="22.525"
              rx="11.2625"
              transform="matrix(1 0 0 -1 83.7052 25.0622)"
              stroke="#DDDDE0"
              strokeWidth="0.979346"
            />
          </g>
        </g>
        <rect
          x="0.489673"
          y="-0.489673"
          width="22.525"
          height="22.525"
          rx="11.2625"
          transform="matrix(1 0 0 -1 83.6506 25.0622)"
          stroke="#DDDDE0"
          strokeWidth="0.979346"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_11_3893"
          x="0.504122"
          y="0.676352"
          width="33.1019"
          height="33.102"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.93804" />
          <feGaussianBlur stdDeviation="2.3994" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3893"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3893"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_11_3893"
          x="-7.85406"
          y="-9.21135"
          width="49.9238"
          height="49.9238"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.7535"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_11_3893"
          />
          <feOffset dy="1.46125" />
          <feGaussianBlur stdDeviation="5.72811" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.372549 0 0 0 0 0.356863 0 0 0 0 0.968627 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3893"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3893"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_11_3893"
          x="26.62"
          y="0.676352"
          width="33.1019"
          height="33.102"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.93804" />
          <feGaussianBlur stdDeviation="2.3994" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3893"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3893"
            result="shape"
          />
        </filter>
        <pattern
          id="pattern0_11_3893"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_11_3893"
            transform="scale(0.00666667 0.00641026)"
          />
        </pattern>
        <filter
          id="filter3_d_11_3893"
          x="18.2637"
          y="-9.21135"
          width="49.9238"
          height="49.9238"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.7535"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_11_3893"
          />
          <feOffset dy="1.46125" />
          <feGaussianBlur stdDeviation="5.72811" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.372549 0 0 0 0 0.356863 0 0 0 0 0.968627 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3893"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3893"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_11_3893"
          x="52.7359"
          y="0.676352"
          width="33.1019"
          height="33.102"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.93804" />
          <feGaussianBlur stdDeviation="2.3994" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3893"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3893"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_11_3893"
          x="44.3796"
          y="-9.21135"
          width="49.9237"
          height="49.9238"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.7535"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_11_3893"
          />
          <feOffset dy="1.46125" />
          <feGaussianBlur stdDeviation="5.72811" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.372549 0 0 0 0 0.356863 0 0 0 0 0.968627 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3893"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3893"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_11_3893"
          x="78.8518"
          y="0.676352"
          width="33.1019"
          height="33.102"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.93804" />
          <feGaussianBlur stdDeviation="2.3994" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3893"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3893"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_11_3893"
          x="70.4955"
          y="-9.21135"
          width="49.9237"
          height="49.9238"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.7535"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_11_3893"
          />
          <feOffset dy="1.46125" />
          <feGaussianBlur stdDeviation="5.72811" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.372549 0 0 0 0 0.356863 0 0 0 0 0.968627 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11_3893"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11_3893"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_11_3893"
          x1="94.5864"
          y1="9.87154"
          x2="91.1214"
          y2="20.2061"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#114A8B" />
          <stop offset="1" stopColor="#0669BC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11_3893"
          x1="95.6875"
          y1="14.6783"
          x2="94.8737"
          y2="14.9561"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.3" />
          <stop offset="0.071" stopOpacity="0.2" />
          <stop offset="0.321" stopOpacity="0.1" />
          <stop offset="0.623" stopOpacity="0.05" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11_3893"
          x1="95.2391"
          y1="9.57057"
          x2="99.0441"
          y2="19.805"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3CCBF4" />
          <stop offset="1" stopColor="#2892DF" />
        </linearGradient>
        <clipPath id="clip0_11_3893">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 5.30292 26.0415)"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_11_3893">
          <rect
            width="9.55838"
            height="11.4701"
            fill="white"
            transform="matrix(-1 0 0 -1 21.5016 20.1646)"
          />
        </clipPath>
        <clipPath id="clip2_11_3893">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 31.4188 26.0415)"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip3_11_3893">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 57.5347 26.0415)"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip4_11_3893">
          <rect
            width="10.323"
            height="11.4701"
            fill="white"
            transform="translate(63.9833 8.6958)"
          />
        </clipPath>
        <clipPath id="clip5_11_3893">
          <rect
            width="23.5043"
            height="23.5043"
            rx="11.7522"
            transform="matrix(1 0 0 -1 83.6506 26.0415)"
            fill="white"
          />
        </clipPath>
        <image
          id="image0_11_3893"
          width="576"
          height="156"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
}
